export default {
  styleOverrides: {
    paper: {
      backgroundColor: '#2e2e2e',
    },
  },
};
